export default {
  client: null,
  clientInfo: null,
  clients: [],
  categories: [],
  languages: [],
  homeActive: 'collaboration'
}
